import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'

Vue.use(Vuex);

//创建Vuex实例
const store = new Vuex.Store({
  state: {
    api: {//api链接
      demo: 'http://demo.kssina.com/g_ev/api.php?json=',//接口demo
      //demo: 'https://insure-test.giant.com.cn/',//接口demo
      //common: 'https://project.kssina.com/giant_shop_new/index.php/',//接口
      common: 'https://e-gw-test.giant.com.cn/index.php/',//接口
      
      jf_api: 'https://jf-test.giant.com.cn/index.php/', //积分商城
      opo_api: 'https://opo-test.giant.com.cn/opo/index.php/', //opo
      opo_message: 'https://opo-test.giant.com.cn', //opo消息通知
      e_api: 'https://e-gw-test.giant.com.cn/index.php/', //在线商城
      map_api: 'https://map-test.giant.com.cn/index.php/', //骑游地图
      org_api: 'https://org-api-test.giant.com.cn/', //组织中台接口

      insurance_api: 'https://insure-test.giant.com.cn/api.php/', //保险接口

      login_api: 'https://sso-test.giant.com.cn/xxl-sso-server/sso', //单点登录接口

      //admin: 'https://e-new-test.giant.com.cn/admin.php/',//后台接口，上传图片用
    },
    externalurl: {//外部链接
      jf_url: 'https://jf-test.giant.com.cn/index.php', //积分商城
      e_url: 'https://e-test.giant.com.cn', //在线商城
      map_url: 'https://map-test.giant.com.cn/index.php', //骑游地图
      insurance: 'https://insure-test.giant.com.cn',//保险中台 https://insure-test.giant.com.cn/#/
      club: 'https://club-test.giant.com.cn', //俱乐部

      giant_url: 'https://u-api-test.giant.com.cn/index.php',

      banner_url: 'https://dlinesso-test.giant.com.cn/index.php/api/app_sso_login?token=',

      opo: 'https://opo-test.giant.com.cn',
      banner: 'https://opo-test.giant.com.cn/opo/index.php/api/get_app_banner_list', 
      chat: 'https://chat-test.giant.com.cn', 
      maintain_url: 'https://maintain-test.giant.com.cn', 
    },

    DLINE_ENVIRONMENT: true,//true 测试环境 false 正式环境

    loginUser: {},//登录用户信息

    browser: (function (ua) {
      var a = new Object();
      var b = {
        //micromessenger: /micromessenger/.test(ua),
        msie: /msie/.test(ua) && !/opera/.test(ua),
        opera: /opera/.test(ua),
        safari: /webkit/.test(ua) && !/chrome/.test(ua),
        firefox: /firefox/.test(ua),
        edge: /edge/.test(ua),
        trident: /trident/.test(ua),
        chrome: /chrome/.test(ua)
      };
      var vMark = "";
      for (var i in b) {
        if (b[i]) { vMark = i; break; }//"safari" == i ? "version" : i;
      }
      b.version = vMark && RegExp("(?:" + vMark + ")[\\/: ]([\\d.]+)").test(ua) ? RegExp.$1 : "0";
      b.ie = b.msie;
      b.ie6 = b.msie && parseInt(b.version, 10) == 6;
      b.ie7 = b.msie && parseInt(b.version, 10) == 7;
      b.ie8 = b.msie && parseInt(b.version, 10) == 8;

      //if(vMark == "trident") vMark = "ie11";

      a.b = vMark;
      a.v = b.version;
      a.m = /mobile/i.test(ua);
      a.wx = /MicroMessenger/i.test(ua);
      a.wxminiprogram = /miniProgram/i.test(ua);
      a.giantapp = /giantapp/i.test(ua);
      a.giantevapp = /giantevapp/i.test(ua);
      a.ios = /\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(ua);
      a.android = ua.indexOf('Android') > -1 || ua.indexOf('Linux') > -1;
      a.huawei=/huawei/i.test(ua);
      a.honor=/honor/i.test(ua);
      
      return a;
    })(window.navigator.userAgent.toLowerCase()),

  },
  getters: {//相当于计算属性
    // themeheaderBgSrc(state){
    //   if( typeof state.theme == 'object' && state.theme ){
    //     if( state.theme.headerBgSrc && state.theme.headerBgSrc.indexOf('linear-gradient') != -1 ){
    //       return state.theme.headerBgSrc;
    //     } else if(state.theme.headerBgSrc) {
    //       return 'url('+ state.theme.headerBgSrc +')';
    //     } else {
    //       return '';
    //     }
    //   } else {
    //     return '';
    //   }
    // },
  },
  mutations: {//逻辑处理，同步
    updateState( state, data ){//通用修改值
      state[data.label] = data.data;
    },
    changeApi(state, n) {//改变api链接
      if (n) {
        for (const key in n) {
          if (n.hasOwnProperty(key)) {
            state.api[key] = n[key]
          }
        }
      }
    },
    changeExternalurl(state, n) {//改变外部链接
      if (n) {
        for (const key in n) {
          if (n.hasOwnProperty(key)) {
            state.externalurl[key] = n[key]
          }
        }
      }
    },
    changeEnvironment(state) {//正式环境撤掉“测试”标志
      state.DLINE_ENVIRONMENT = false;
    },
    changeCartCount(state, n) {//修改购物车内商品数量
      state.cartCount = n;
    },

    updateLoginUser(state, data) {//修改登录用户数据
      state.loginUser = data;
    },

    updateBikeNow( state, data ){//切换当前的车
      state.bikeNow = data;
    },




  },
  actions: {//类似 mothods，异步

  }
});

//正式环境
if (window.location.host == 'found.giant.com.cn' || window.location.host == 'found-yu.giant.com.cn') {
  store.commit('changeApi', {
    jf_api: 'https://jf.giant.com.cn/index.php/', //积分商城
    opo_api: 'https://opo.giant.com.cn/opo/index.php/', //opo
    e_api: 'https://e-gw.giant.com.cn/index.php/', //在线商城
    map_api: 'https://map.giant.com.cn/index.php/', //骑游地图
    opo_message: 'https://opo.giant.com.cn', //opo消息通知
    login_api: 'https://sso.giant.com.cn/xxl-sso-server/sso', //单点登录接口
    org_api: 'https://org-api.giant.com.cn/', //组织中台接口
  });
  store.commit('changeExternalurl', {
    opo: 'https://opo.giant.com.cn',
    jf_url: 'https://jf.giant.com.cn/index.php', //积分商城
    e_url: 'https://e.giant.com.cn', //在线商城
    map_url: 'https://map.giant.com.cn/index.php', //骑游地图
    banner: 'https://opo.giant.com.cn/opo/index.php/api/get_app_banner_list',
    chat: 'https://chat.giant.com.cn',
    club: 'https://club.giant.com.cn', //俱乐部
    banner_url: 'https://dlinesso.giant.com.cn/index.php/api/app_sso_login?token=',
    insurance: 'https://insure.giant.com.cn',//保险中台
    giant_url: 'https://u-api.giant.com.cn/index.php',
    maintain_url: 'https://maintain.giant.com.cn', 
  });
  store.commit('changeEnvironment');
}



//导出store
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js